<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <footer class="site-footer">
    <div class="site-footer__brand">
      <picture>
        <source srcset="/logo-256.avif" type="image/avif" />
        <source srcset="/logo-256.webp" type="image/webp" />
        <img src="/logo-256.png" alt="" width="256" height="256" loading="lazy" />
      </picture>
      <div>
        <strong>Carib Wave Logistics</strong>
        <span>Shipping from the U.S. to Jamaica</span>
      </div>
    </div>
    <div class="site-footer__route" aria-hidden="true">
      <span>US</span><i></i><span>JA</span>
    </div>
    <nav class="site-footer__nav" aria-label="Footer">
      <RouterLink to="/ship">Services</RouterLink>
      <RouterLink to="/locations">Locations</RouterLink>
      <RouterLink to="/help">FAQs</RouterLink>
      <RouterLink to="/privacy">Privacy</RouterLink>
      <RouterLink to="/terms">Terms</RouterLink>
      <RouterLink to="/contact">Contact</RouterLink>
    </nav>
    <div class="site-footer__contact">
      <a class="site-footer__phone" href="tel:+18763400989" aria-label="Call Carib Wave Logistics">
        <span aria-hidden="true">☎</span> +1 (876) 340-0989
      </a>
      <a class="site-footer__email" href="mailto:hello@caribwaveja.com" aria-label="Email Carib Wave Logistics">
        <span aria-hidden="true">✉</span> hello@caribwaveja.com
      </a>
    </div>
    <div class="site-footer__base">
      <span>© {{ new Date().getFullYear() }} Carib Wave Logistics</span>
      <span class="site-footer__credit">
        Built with <span aria-label="love" role="img">♥</span> in Kingston, Jamaica by
        <a href="https://tommygooden.com?ref=caribwaveja.com" target="_blank" rel="noopener noreferrer">Tommy Gooden</a>
      </span>
      <span class="site-footer__kin data-label">KIN · JAMAICA</span>
    </div>
  </footer>
</template>
